import { useTranslation } from 'react-i18next';
import CategoryDropdown from '@/components/feature/CategoryDropdown';
import { categories, categoryImages } from '@/mocks/categories';

export default function Categories() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="text-center max-w-2xl mx-auto mb-10">
        <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-4xl mb-3">
          {t('categories.title')}
        </h2>
        <p className="text-foreground-600 text-sm md:text-base">{t('categories.subtitle')}</p>
      </div>

      <div className="mb-10">
        <CategoryDropdown />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
        {categories.map((cat) => (
          <a
            key={cat.id}
            href={cat.link}
            target="_blank"
            rel="noopener nofollow"
            className="group flex flex-col bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
          >
            <div className="w-full h-40 md:h-44 overflow-hidden bg-background-100">
              <img
                src={categoryImages[cat.id]}
                alt={t(`cat.${cat.id}`)}
                title={`${t(`cat.${cat.id}`)} · USFans Spreadsheet`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex items-center justify-between p-4">
              <span className="font-heading font-semibold text-foreground-900 text-sm md:text-base whitespace-nowrap">
                {t(`cat.${cat.id}`)}
              </span>
              <span className="flex items-center justify-center w-7 h-7 rounded-full bg-background-100 text-foreground-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className="ri-arrow-right-up-line text-sm" />
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}